import React, { Component } from "react";
import { Box } from "@material-ui/core";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import FocusTable from "./FocusTable";
import RccCard from "../RccCard";

class PullInCard extends Component {
  state = {
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    this.setState({ loading: true, error: null });
    try {
      await this.props.getFocusRecommendationData();
    } catch (error) {
      console.error("Error loading pull-in data:", error);
      this.setState({
        error: "Failed to load pull-in data. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading } = this.state;
    const { FocusRecommendationData, title, redirectToDashboard, user } =
      this.props;

    // Get currentFiscalQuarter from user
    const currentFiscalQuarter = user?.currentFiscalQuarter;

    const tableData = FocusRecommendationData?.pullInTableData || [];
    const tableConfig = FocusRecommendationData?.pullInTableConfig || [];

    // Determine effective loading state (initial load or missing specific data)
    const isEffectiveLoading =
      loading &&
      (!FocusRecommendationData || !FocusRecommendationData.pullInTableData);

    return (
      <RccCard
        title={title || "Focus - Pull Ins"}
        isLoading={isEffectiveLoading}
        redirectToDashboard={redirectToDashboard}
        focusVariant={"current"}
        focusLabel={"Current Qtr Recommendations"}
        // Placeholder handlers - replace with real logic if needed
        onInfoClick={() => console.log("Info clicked")}
        onZoomClick={() => console.log("Zoom clicked")}
      >
        <Box
          style={{ flex: 1, width: "100%", overflow: "hidden", height: "100%" }}
        >
          <FocusTable
            data={tableData}
            config={tableConfig}
            loading={loading}
            emptyMessage={`Pull in recommendations for ${currentFiscalQuarter} opportunities are not yet available.`}
          />
        </Box>
      </RccCard>
    );
  }
}

/* Redux */
const mapStateToProps = (state) => {
  const { user, FocusRecommendationData } = state.app;
  return {
    user: user,
    company: user?.company,
    FocusRecommendationData,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getFocusRecommendationData: () => {
    return appService.getFocusRecommendationData().then(
      (json) => {
        dispatch({ type: "get_Focus_Recommendation", json });
        return json;
      },
      (error) => {
        console.error("API error:", error);
        throw error;
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PullInCard);
